export default function(errorInfo){
  console.warn('has error info',errorInfo)
  var error=new Error(JSON.stringify({
    name:errorInfo.name,
    intro:(errorInfo.code!==undefined?'[No.'+errorInfo.code+']':'')+errorInfo.intro,
    url:errorInfo.url,
    req:errorInfo.req,
    res:errorInfo.res,
  }))
  error.name='stringifyError';
  alert(errorInfo.intro);
};
